require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2007-05-04-road-trip.json") })
        }
      }, "path---articles-2007-05-04-road-trip");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2007-05-04-road-trip!./.cache/json/articles-2007-05-04-road-trip.json
// module id = 510
// module chunks = 231608221292675